// extracted by css-extract-rspack-plugin
export default {"modalContainer":"_22f851ae","spinnerWrapper":"_28ecb34c"};